<template>
  <div>
    <common-dialog ref="dialog" show-save-button width="850px" unit="设备任务" edit-title id-key="DisableVersionId"
      :data="data" form-label-width="85px" :form-rules="rules" :save-func="api.save" :get-data-func="api.info"
      close-on-saved @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed"
      :before-save="onBeforeSave" @details-opened="onDetailsOpened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="版本名" prop="VersionName">
              <el-input type="text" v-model="data.VersionName" placeholder="请输入版本名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        -->
      </template>
    </common-dialog>
    <device-dialog ref="deviceDialog" in-dialog selectable @select="onSelect" @select-multiple="selectMultiple" :multiple="data.DisableVersionId==0"></device-dialog>
  </div>
</template>
<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/disableversion";
  import devApi from "@/api/op/device";
  import appApi from "@/api/op/app";
  import deviceDialog from "@/components/operate/device/listDialog"
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      deviceDialog
    },
    data() {
      return {
        data: {
          DisableVersionId: 0,
          VersionName: null,
        },
        DeviceNo: [],
        DeviceNos: "",
        IMEIS: "",
        DeviceIds: [],
        deviceList: [],
        appList: [],
        api,
        devApi,
        appApi,
        rules: {
          VersionName: [{ required: true, message: "请先填写版本名" }],
        },
      };
    },
    methods: {
      onCreateOpened() {
        this.getOption();
      },
      onEditOpened(data) {
        this.getOption();
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      getOption() {
        this.devApi.list({}).then(res => {
          if(res.Code==0) this.deviceList = res.Data;
        })
        this.loading(true);
        this.appApi.list({}).then(res => {
          this.loading(false);
          if(res.Code==0) this.appList = res.Data;
        })
      },
      appChange(url) {
        if(!this.data.Remark) {
          var obj = this.appList.find(x => x.FileUrl == url);
          this.data.Remark = obj.VersionNo;
        }
      },
      onDeviceDialogOpen() {
        this.$refs.deviceDialog.open().then((that) => {
          that.getData({});
        });
      },
      onSelect(v) {
        this.data.DeviceId = v.DeviceId;
      },
      imei(id) {
        if(id) {
          var obj = this.deviceList.find(x => x.DeviceId == id);
          return obj?obj.ImeiMac:"";
        } else return "";
      },
      selectMultiple(v) {
        v.forEach(e => {
          if(this.DeviceIds.indexOf(e.DeviceId) == -1) {
            this.DeviceIds.push(e.DeviceId);
            this.DeviceNo.push(e.DeviceNo);
            if(this.DeviceNos) this.DeviceNos += ",";
            this.DeviceNos += e.DeviceNo;
            if(this.IMEIS) this.IMEIS += ",";
            this.IMEIS += e.ImeiMac;
          }
        })
      },
      onBeforeSave() {
        if(this.data.DisableVersionId==0) {
          // if(this.DeviceIds.length == 0) {
          //   this.$message.error("请选择IMEI");
          //   return false;
          // }
          if(this.data.TaskType!=2 && this.data.TaskType != 6) this.data.TaskParam = "";
          this.api.save({
            DisableVersionId: 0,
            VersionName: this.data.VersionName,
            //Remark: this.data.Remark,
          }).then(res => {
            if(res.Code==0) {
              this.$message.success("保存成功");
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          })
          return false;
        }
      },
      onClosed() {
        this.deviceList = [];
        this.appList = [];
        this.DeviceNos = "";
        this.IMEIS = "";
        this.DeviceNo = [];
        this.DeviceIds = [];
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>